import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'imageselector',
  components: {},
  props: ['data'],

  data () {
    return {
      obj: '',
      nameInput: '',
      imgDetails: '',
      dataFiles: '',
      isPdf: false
    }
  },

  mounted () {
    this.GetPlanta()
  },

  methods: {
    downloadFileVistoria (data) {
      let base64 = data.arquivo
      let a = document.createElement('a')
      a.href = 'data:application/pdf;base64,' + base64
      a.download = data.descricao
      a.click()
    },
    openfilevistoria () {
      let file = document.getElementById('img-planta')
      file.click()
    },
    SendFileVistoriaTecnica (files) {
      if (files.target.files[0].type.includes('pdf') || files.target.files[0].type.includes('png') || files.target.files[0].type.includes('jpg') || files.target.files[0].type.includes('jpeg')) {
        loading.push()

        let UrlConvert = URL.createObjectURL(files.target.files[0])
        let obj = {
          data: files.target.files[0],
          url: UrlConvert
        }
        let conf = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let img = new FormData()
        img.append('img', obj.data)
        EnterpriseRepository.SavePlantaEnterprise(this.data.id, img, conf)
          .then(Response => {
            this.GetPlanta()
            loading.pop()
            this.isPdf = true
            toast.success(`Planta adicionada com sucesso`)
            loading.pop()
          })
          .catch(() => {
            toast.error(`Erro ao adicionar a planta, verifique se a imagem é jpg ou se o arquivo é PDF`)
            loading.pop()
          })
      } else {
        toast.error(`Erro ao adicionar a planta, verifique se a imagem é jpg ou se o arquivo é PDF`)
        loading.pop()
      }
    },

    GetValueFile (e) {
      this.nameInput = e.target.files[0].name
    },
    show () {
      this.$refs.images.show()
    },
    cancelImage () {
      this.$refs.images.hide()
      document.querySelector('.inputHidden').value = ''
      this.nameInput = ''
    },
    imageDetails (obj) {
      this.imgDetails = obj
      this.$refs.modalPdfImagemSelector.show()
    },
    addImg (e) {
      document.querySelector('.inputHidden').click()
    },

    GetPlanta () {
      EnterpriseRepository.GetPlantaEnterprise(this.data.id)
        .then(Response => {
          this.dataFiles = Response.data
          if (this.dataFiles !== '') {
            this.isPdf = true
          } else {
            this.isPdf = false
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    RemovePlanta () {
      loading.push()
      EnterpriseRepository.RemovePlantaEnterprise(this.data.id)
        .then(res => {
          this.GetPlanta()
          this.isPdf = false
          // document.querySelector('.inputHidden').value = ''
          // this.nameInput = ''
          this.dataFiles = ''
          if (res.status === 200) {
            toast.success(`Planta removida com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao remover a planta`)
          loading.pop()
        })
    },
    GetEnterpriseFilters () {
      EnterpriseRepository.GetEnterprisesFilter()
    },
    modalImg (e) {
      // Get the modal
      this.$refs.images.hide()
      var modal = document.getElementById('myModal')

      // Get the image and insert it inside the modal - use its "alt" text as a caption
      var img = e.target
      var modalImg = document.getElementById('img01')
      var captionText = document.getElementById('caption')
      modal.style.display = 'block'
      modalImg.src = img.src
      captionText.innerHTML = img.alt
      // Get the <span> element that closes the modal
      var span = document.querySelector('.close')

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = 'none'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/imageselector/imageselector.js